export default "__VITE_ASSET__BWHfH32o__"